import { LinkTypes } from "actions/types";
import axios from "axios";
import { serverError } from "actions/error";
import { setCookie } from "actions/application";

export function setMultigameEnabled(bol) {
  return (dispatch, getState) => {
    return dispatch({
      type: LinkTypes.SET_MULTIGAME_ENABLED,
      payload: bol,
    });
  };
}

export function setGameProviderImagesEnabled(bol)  {
  return (dispatch, getState) => {
    const state = getState();
    const currentValue = state.profile.getIn(['preferences', 'showProviderLogoOnGames']);
    const sessionId = getState().cookie.get("sessionId");
    const srvcred = JSON.parse(getState().cookie.get("srvcred") || "{}");
    const { gs, uuid } = srvcred[sessionId] || {};

    dispatch({
      type: 'SET_GAME_PROVIDER_IMAGES_ENABLED',
      payload: bol,
      meta: {
        gs: gs,
        uuid: uuid
      }
    });

    const updatePreferencesLink = state.links.get('update-preferences');
    const authToken = getState().security.get("sessionId");

    if (updatePreferencesLink && authToken) {
      const currentAllowMultiGamePlay = state.links.get('allowMultiGamePlay');
      
      const payload = {
        showProviderLogoOnGames: bol,
        allowMultiGamePlay: currentAllowMultiGamePlay
      };

      return fetch(updatePreferencesLink.get("href"), {
        method: updatePreferencesLink.get("method"),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
          'gs': gs,
          'uuid': uuid
        },
        body: JSON.stringify(payload)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to update preferences');
        }
        return response.json();
      })
      .then(data => {
        if (data.refreshRequired) {
          console.log('Preferences updated - refresh required');
        }
        return data;
      })
      .catch(error => {
        dispatch({
          type: 'SET_GAME_PROVIDER_IMAGES_ENABLED',
          payload: currentValue,
          meta: {
            gs: gs,
            uuid: uuid
          }
        });
        console.error('Error updating preferences:', error);
        throw error;
      });
    } else {
      dispatch({
        type: 'SET_GAME_PROVIDER_IMAGES_ENABLED',
        payload: currentValue,
        meta: {
          gs: gs,
          uuid: uuid
        }
      });
    }
  };
}

export function fetchLinks() {
  return (dispatch, getState) => {
    try {
      var route = getState().config.get("route");
      var host = getState().config.get("host");
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var href = route.get("href");
      var url = `${host}${href}`;
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: LinkTypes.FETCH_LINKS,
      payload: {
        headers,
        route,
        url,
      },
    });
    return axios({
      method,
      headers,
      url,
      withCredentials: true,
    })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        dispatch(serverError(error));
        throw error;
      });
  };
}

export function setLinks(payload) {
  return (dispatch, getState) => {
    let sessionId = getState().cookie.get("sessionId");
    let srvcred = JSON.parse(getState().cookie.get("srvcred"));
    srvcred[sessionId] = {
      gs: payload.gs,
      uuid: payload.uuid,
    };
    dispatch(
      setCookie({
        srvcred: JSON.stringify(srvcred),
      })
    );
    //payload.allowMultiGamePlay = true; //HARDCODE MULTI GAME
    return dispatch({
      type: LinkTypes.SET_LINKS,
      payload: payload,
    });
  };
}
